export default {
    pageLoad: true,
    globle: {},
    navigator: null,
    promotion: {},
    scrollFetching: false,
    homePage: {
        suggestVideos: [],
        menuVideoList: [],
    },
    playPage: {
        videoDetail: {},
        guesslike: [],
        player: null
    },
    categoryPage: {
        list: [],
        total: null
    },
    resultPage: {
        list: [],
        total: null
    }
}; 